import { ref, onMounted } from 'vue';

// Defers `run` (assumed synchronous-ish and potentially expensive — the
// physics sweeps behind Graph/Trajectory/Full Marks) until after the
// browser has painted the current frame, via a double requestAnimationFrame
// (the standard "wait for the next paint" idiom). Without this, a heavy
// computation kicked off in onMounted runs on the very same tick the
// panel's own open animation (see use_height_transition.js) is trying to
// measure/animate height on — the animation never gets a chance to paint
// before the computation blocks the main thread, so the panel just snaps
// open once it finally finishes instead of animating in. Deferring it lets
// that first frame (an empty/placeholder layout) paint and the open
// animation actually start before the expensive work begins.
//
// `pending` stays true until `run` has finished once — callers gate their
// expensive content behind it (e.g. `v-if="!pending"`) so nothing forces
// an early evaluation of whatever `run` populates (a computed() read in
// the template would otherwise trigger it immediately on mount, defeating
// the defer).
export function useDeferredCompute(run) {
  const pending = ref(true);

  onMounted(() => {
    requestAnimationFrame(() => {
      requestAnimationFrame(async () => {
        await run();
        pending.value = false;
      });
    });
  });

  return pending;
}
